import * as HttpService from './http-client'

export function flexformCaptureContext(mode) {
  return new Promise((resolve, reject) => {
    var targetOrigin = window.origin

    // Allows the full form to be iframed to allow for NAR's Hosted
    // Page to be iframed by outside vendors.
    // NOTE: Current implementation only works for one layer of nested frames.
    try {
      if (window.location !== window.parent.location) {
        var browserOrigin = document.referrer.split('/[^/]')[0].slice(0, -1)
        targetOrigin += ` ${browserOrigin}`
      }
    } catch (e) {
      log.error(e)
    }

    HttpService.post(`${baseUrl(mode)}/api/flexform-capture-context`, {
      origin: targetOrigin,
      version: 'v2'
    })
      .then(data => {
        if (data.error) {
          reject(data.error)
        } else {
          resolve(data.captureContext)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function paymentTypes(mode, associationId) {
  return new Promise((resolve, reject) => {
    HttpService.get(`${baseUrl(mode)}/api/payment-types?associationId=${associationId}`)
      .then(data => {
        if (data.error) {
          reject(data.error)
        } else {
          resolve(data.paymentTypes)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function applePayValidateMerchant(mode, displayName) {
  return new Promise((resolve, reject) => {
    HttpService.post(`${baseUrl(mode)}/api/apple-pay-validate-merchant`, {
      initiativeContext: window.location.hostname,
      displayName: displayName
    })
      .then(data => {
        if (data.error) {
          reject(data)
        } else {
          resolve(JSON.parse(data.captureContext))
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

function baseUrl(mode) {
  switch (mode) {
  case 'prod':
    return process.env.BASE_URL_RECN_PROD
  case 'beta':
  case 'test':
    return process.env.BASE_URL_RECN_BETA
  case 'qa':
    return process.env.BASE_URL_RECN_QA
  }
}
